import { render, staticRenderFns } from "./embed-modal.vue?vue&type=template&id=39248558&scoped=true&"
import script from "./embed-modal.vue?vue&type=script&lang=js&"
export * from "./embed-modal.vue?vue&type=script&lang=js&"
import style0 from "./embed-modal.vue?vue&type=style&index=0&id=39248558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39248558",
  null
  
)

export default component.exports